module.exports = __webpack_public_path__ + "img/epr@2x.90624013.webp";